/* Liability constants — single source of truth for the frontend. */

export const LIABILITY_TYPES = [
  { value: 'auto_loan',     label: 'Auto loan' },
  { value: 'credit_card',   label: 'Credit card' },
  { value: 'margin_loan',   label: 'Margin loan' },
  { value: 'mortgage',      label: 'Mortgage' },
  { value: 'personal_loan', label: 'Personal loan' },
  { value: 'tax_owed',      label: 'Tax owed' },
];

export const LIABILITY_TYPE_LABEL = LIABILITY_TYPES.reduce(
  (acc, t) => { acc[t.value] = t.label; return acc; }, {},
);

/**
 * Per-type field schema. `required: true` means the backend enforces it
 * (mirrors `_REQUIRED_BY_TYPE` in routes/liabilities.py). `kind` drives the
 * input type. Order here is the order shown in the modal.
 */
export const LIABILITY_FIELDS_BY_TYPE = {
  mortgage: [
    { key: 'original_principal', label: 'Original principal',  kind: 'number', required: true },
    { key: 'outstanding_balance',label: 'Outstanding balance', kind: 'number', required: true },
    { key: 'interest_rate',      label: 'Interest rate (% APR)', kind: 'number', required: true, step: '0.01' },
    { key: 'start_date',         label: 'Start date',          kind: 'date' },
    { key: 'maturity_date',      label: 'Maturity date',       kind: 'date', required: true },
    { key: 'secured_property',   label: 'Secured property',    kind: 'text', required: true },
  ],
  auto_loan: [
    { key: 'original_principal',  label: 'Original principal',  kind: 'number', required: true },
    { key: 'outstanding_balance', label: 'Outstanding balance', kind: 'number', required: true },
    { key: 'interest_rate',       label: 'Interest rate (% APR)', kind: 'number', required: true, step: '0.01' },
    { key: 'start_date',          label: 'Start date',          kind: 'date' },
    { key: 'maturity_date',       label: 'Maturity date',       kind: 'date', required: true },
    { key: 'vehicle_description', label: 'Vehicle description', kind: 'text', required: true },
  ],
  personal_loan: [
    { key: 'original_principal',  label: 'Original principal',  kind: 'number', required: true },
    { key: 'outstanding_balance', label: 'Outstanding balance', kind: 'number', required: true },
    { key: 'interest_rate',       label: 'Interest rate (% APR)', kind: 'number', required: true, step: '0.01' },
    { key: 'start_date',          label: 'Start date',          kind: 'date' },
    { key: 'maturity_date',       label: 'Maturity date',       kind: 'date', required: true },
  ],
  credit_card: [
    { key: 'credit_limit',       label: 'Credit limit',       kind: 'number', required: true },
    { key: 'outstanding_balance',label: 'Outstanding balance',kind: 'number', required: true },
    { key: 'interest_rate',      label: 'Interest rate (% APR)', kind: 'number', required: true, step: '0.01' },
    { key: 'minimum_payment',    label: 'Minimum monthly payment', kind: 'number' },
  ],
  margin_loan: [
    { key: 'original_principal',  label: 'Original principal',  kind: 'number', required: true },
    { key: 'outstanding_balance', label: 'Outstanding balance', kind: 'number', required: true },
    { key: 'interest_rate',       label: 'Interest rate (% APR)', kind: 'number', required: true, step: '0.01' },
    { key: 'secured_holding',     label: 'Secured holding',     kind: 'text', required: true,
      hint: 'Which investment is this margin loan secured against?' },
  ],
  tax_owed: [
    { key: 'tax_year',            label: 'Tax year',            kind: 'text', required: true,
      placeholder: '2024 or 2024-25' },
    { key: 'outstanding_balance', label: 'Amount owed',         kind: 'number', required: true },
    { key: 'due_date',            label: 'Due date',            kind: 'date', required: true },
  ],
};

/**
 * Liability-type → visual category used for badges on the SoNW card.
 */
export const LIABILITY_TYPE_COLOR = {
  mortgage:      'bg-blue-50 text-blue-700 border-blue-200',
  auto_loan:     'bg-sky-50 text-sky-700 border-sky-200',
  personal_loan: 'bg-purple-50 text-purple-700 border-purple-200',
  credit_card:   'bg-amber-50 text-amber-700 border-amber-200',
  margin_loan:   'bg-rose-50 text-rose-700 border-rose-200',
  tax_owed:      'bg-orange-50 text-orange-700 border-orange-200',
};
